import { render, staticRenderFns } from "./staticPage.vue?vue&type=template&id=044d424b&scoped=true"
import script from "./staticPage.vue?vue&type=script&lang=js"
export * from "./staticPage.vue?vue&type=script&lang=js"
import style0 from "./staticPage.vue?vue&type=style&index=0&id=044d424b&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "044d424b",
  null
  
)

export default component.exports